import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import styles from '../styles/AdvancedBikeCTA.module.css'
import slide1 from '../assets/slider-1.jpeg'
import slide2 from '../assets/slider-2.webp'
import slide3 from '../assets/slider-3.webp'
import { useNavigate } from 'react-router-dom'

import "./SlideTwo.css"
const AnimatedBikeWheel = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" className="svg">
    <circle cx="50" cy="50" r="48" stroke="white" strokeWidth="4" fill="none" />
    {[...Array(8)].map((_, i) => (
      <motion.line
        key={i}
        x1="50"
        y1="50"
        x2="100"
        y2="50"
        stroke="white"
        strokeWidth="2"
        initial={{ rotate: i * 45 }}
        animate={{ rotate: i * 45 + 360 }}
        transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
      />
    ))}
  </svg>
)

const BikeFeature = ({ icon, text }) => (
  <motion.div 
    className={styles.feature}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
  >
    <span className={styles.featureIcon}>{icon}</span>
    <span>{text}</span>
  </motion.div>
)

const SlideTwo = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const images = [slide1, slide2, slide3]
  const navigate = useNavigate()


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 10000);
  
    return () => clearInterval(interval);
  }, []);


  return (
    <div className={styles.ctaContainer} style={{ marginBottom: "50px"}}>
      <AnimatePresence mode="wait">
        <motion.div 
          key={currentImageIndex}
          className={styles.ctaBackground}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        >
          <img
            src={images[currentImageIndex]}
            alt="Bicicleta en acción"
          />
        </motion.div>
      </AnimatePresence>
      
      <div className={styles.ctaContent}>
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className={styles.ctaTitle}>
            Conquista cada camino
          </h2>
        </motion.div>
        <motion.p 
          className={styles.ctaDescription}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Nuestras bicicletas están listas para cualquier desafío.
        </motion.p>
        
        <motion.div 
          className={styles.ctaFeatures}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <BikeFeature icon="🚀" text="Velocidad máxima" />
          <BikeFeature icon="🌿" text="Eco-friendly" />
          <BikeFeature icon="🔧" text="Fácil mantenimiento" />
        </motion.div>
        
        <motion.button
          className={styles.ctaButton}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate("/bicicletas")}
        >
          Descubre tu próxima aventura
        </motion.button>
        
        <motion.div 
          className={styles.bikeWheel}
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        >
          <AnimatedBikeWheel />
        </motion.div>
      </div>
    </div>
  )
}

export default SlideTwo

